import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollable", "todayLine"]
  static values = { colWidth: { type: Number, default: 120 } }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)

    // Auto-scroll to today on load
    if (this.hasTodayLineTarget) {
      requestAnimationFrame(() => this.scrollToToday(false))
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    const tag = event.target.tagName
    if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return

    if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.scrollBy(-3)
    } else if (event.key === "ArrowRight") {
      event.preventDefault()
      this.scrollBy(3)
    }
  }

  prev() { this.scrollBy(-3) }
  next() { this.scrollBy(3) }

  today() { this.scrollToToday(true) }

  scrollBy(months) {
    const px = months * this.colWidthValue
    this.scrollableTarget.scrollBy({ left: px, behavior: "smooth" })
  }

  scrollToToday(smooth) {
    if (!this.hasTodayLineTarget) return

    const container = this.scrollableTarget
    const line = this.todayLineTarget
    const offset = line.offsetLeft - container.clientWidth / 2

    container.scrollTo({ left: offset, behavior: smooth ? "smooth" : "instant" })
  }
}
